export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-background-100" />

      <div className="absolute top-0 right-0 w-[60%] h-full opacity-[0.07] pointer-events-none hidden md:block">
        <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-primary-400 blur-[120px]" />
        <div className="absolute top-1/4 right-[10%] w-[500px] h-[500px] rounded-full bg-accent-400 blur-[100px]" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-0">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-5 whitespace-nowrap">
              全网热门影视 · 每日同步更新
            </span>

            <h1 className="font-heading text-[32px] md:text-[44px] lg:text-[52px] leading-tight text-foreground-950 mb-4">
              51影院
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 font-normal mt-1">
                奇优影院 · 97影院 · 最新影视全网聚合
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 max-w-[560px] mx-auto lg:mx-0 leading-relaxed mb-3">
              51影院汇聚奇优影院、97影院、窝窝影院、第九影院等热门站点资源，
              覆盖最新电影、热播电视剧、热门综艺，全站高清流畅播放，无需下载即点即看。
            </p>
            <p className="text-sm text-foreground-500 max-w-[560px] mx-auto lg:mx-0 leading-relaxed mb-6">
              每日同步全网更新，涵盖动作、悬疑、喜剧、科幻、爱情、动漫等全类型，
              无论你是追剧党还是电影爱好者，这里都是你的专属私人影院。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mb-7">
              <div className="text-center lg:text-left">
                <span className="block text-2xl font-bold text-primary-600 font-heading">20万+</span>
                <span className="text-xs text-foreground-500">影视资源</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block" />
              <div className="text-center lg:text-left">
                <span className="block text-2xl font-bold text-accent-600 font-heading">每日更新</span>
                <span className="text-xs text-foreground-500">同步全网</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block" />
              <div className="text-center lg:text-left">
                <span className="block text-2xl font-bold text-secondary-600 font-heading">高清流畅</span>
                <span className="text-xs text-foreground-500">即点即看</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热播榜单
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-lg border border-background-300 text-foreground-700 font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line text-lg"></i>
                浏览全部分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative aspect-[4/3] md:aspect-[16/10] lg:aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20home%20theater%20setup%20with%20soft%20ambient%20golden%20lighting%2C%20large%20screen%20displaying%20abstract%20film%20reel%20texture%2C%20cozy%20atmosphere%20with%20warm%20wood%20tones%2C%20modern%20minimalist%20interior%2C%20cinematic%20color%20grading%20with%20rich%20amber%20and%20coral%20accents%2C%20artistic%20composition%2C%20high%20detail&width=800&height=600&seq=hero-cinema-01&orientation=landscape"
                alt="51影院 - 全网影视聚合平台，高清在线观影体验"
                className="w-full h-full object-cover"
                title="51影院 - 全网影视聚合平台"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <span className="px-3 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-800 whitespace-nowrap">
                  <i className="ri-play-circle-fill text-primary-500 mr-1"></i>
                  海量高清资源
                </span>
                <span className="px-3 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-800 whitespace-nowrap">
                  <i className="ri-flashlight-fill text-accent-500 mr-1"></i>
                  极速播放体验
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}